exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".result-page .operate-btn[data-v-2d906d91]{display:flex;justify-content:center;align-items:center}.result-page .operate-btn>div[data-v-2d906d91]{text-align:center;padding:.213333rem 0;border-radius:.213333rem;color:#fff;width:30%;background-color:#00b3f3}.result-page .operate-btn>div[data-v-2d906d91]:first-child{margin-right:.533333rem;background-color:#ccc}.result-page .zf_zfcg[data-v-2d906d91]{font-size:2.133333rem}", ""]);

// exports
